import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DataProvider } from 'projects/packcert-web/src/app/providers/data.provider';
import { Message, SpinnerService, UtilsService } from 'shared-components';
import { ConfiguracionService } from '../../../services/configuracion.service';
import { SessionContextService } from 'projects/packcert-web/src/app/context/session-context.service';

@Component({
    selector: 'app-disenyo-etq-new-edit',
    templateUrl: './new-edit.component.html'
})
export class DisenyoEtqNewEditComponent implements OnInit {

    private _disenyoEtiqueta;

    public newEditForm: UntypedFormGroup;
    public showError: boolean;
    public showApiError: boolean; // evitar mostrar la clase de error en inputs si falla el getById
    public mensajes = new Array<Message>();

    @Input() disenyoEtiquetaId;

    @Output() refresh = new EventEmitter<boolean>();
    @Output() mensaje = new EventEmitter<string>();

    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _dataProvider: DataProvider,
        private readonly _spinnerService: SpinnerService,
        private readonly _configuracionService: ConfiguracionService,
        private readonly _sessionContext: SessionContextService
    ) { }

    ngOnInit() {
        this.newEditForm = this._fb.group({
            des: ['', Validators.required],
            tipoConfeccion: ['', Validators.required]
        });

        if (this.disenyoEtiquetaId) {
            this.getDisenyoEtiqueta();
        }
    }

    public get tiposConfeccion() {
        return this._dataProvider.tiposConfeccion;
    }

    public get isSmallScreen() {
        return this._sessionContext.isSmallScreen();
    }

    public getDisenyoEtiqueta() {
        this._spinnerService.showSpinner();
        this._configuracionService.getDisenyoEtiqueta(this.disenyoEtiquetaId).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this._disenyoEtiqueta = resp;
            this.newEditForm.patchValue({
                des: resp.des,
                tipoConfeccion: this._dataProvider.tiposConfeccion.find( x => +x.value === resp.tipoConfeccionId )
            });
            this.newEditForm.get('tipoConfeccion').disable();
        }, (error) => {
            this.showApiError = true;
            if (error.status === 420) {
                this.mensajes.push({ class: 'error', message: 'global.error.noAccess' });
            } else {
                this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
            }
        });
    }

    public close() {
        this.refresh.emit(false);
    }

    public save() {
        this.checkForm();
        if (this.newEditForm.valid && !this.disenyoEtiquetaId) {
            this._disenyoEtiqueta = {
                des: this.newEditForm.get('des').value,
                tipoConfeccionId: this.newEditForm.get('tipoConfeccion').value.value
            };
            this._spinnerService.showSpinner();
            this._configuracionService.createDisenyoEtiqueta(this._disenyoEtiqueta).toPromise().finally(() => {
                this._spinnerService.hideSpinner();
            }).then((resp) => {
                if (resp) {
                  this._dataProvider.refreshDisenyos();
                  this.refresh.emit(true);
                  this.mensaje.emit('global.success.itemCreated');
                } else {
                  this.showError = true;
                  this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                }
            },
            (error) => {
                this.showError = true;
                this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
            });
        } else if (this.newEditForm.valid && this.disenyoEtiquetaId) {
            this._disenyoEtiqueta = {
                id: this.disenyoEtiquetaId,
                des: this.newEditForm.get('des').value,
            };
            this._spinnerService.showSpinner();
            this._configuracionService.updateDisenyoEtiqueta(this._disenyoEtiqueta).toPromise().finally(() => {
                this._spinnerService.hideSpinner();
            }).then((resp) => {
                this._dataProvider.refreshDisenyos();
                this.refresh.emit(true);
                this.mensaje.emit('global.success.itemUpdated');
            },
            (error) => {
                this.showError = true;
                this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
            });
        }
    }

    private checkForm() {
        this.showError = this.newEditForm.invalid;
        if (this.showError) {
            this.mensajes.push({ class: 'error', message: 'global.error.required' });
        }
    }
}
